import React, { useState, useRef } from 'react';
import '../styles/TherapistAvatar.css';

/**
 * WellnessAvatar component for the Wellness AI web app
 * Displays the wellness rep character.
 * Switches to a GIF when speaking, assumes GIF has integrated mouth animation.
 */
const TherapistAvatar = ({ 
  gender = 'male', 
  isSpeaking = false, 
  currentViseme = 'closed', // Kept for potential future use with static images
  onLoad = () => {}
}) => {
  const [loaded, setLoaded] = useState(false);
  // const [blinking, setBlinking] = useState(false); // Removed blinking state
  const avatarRef = useRef(null);
  
  // Blinking effect removed
  // useEffect(() => {
  //   let blinkInterval;
  //   if (!isSpeaking) { 
  //     blinkInterval = setInterval(() => {
  //       if (Math.random() < 0.1) { 
  //         setBlinking(true);
  //         setTimeout(() => setBlinking(false), 200); 
  //       }
  //     }, 3000); 
  //   } else {
  //     setBlinking(false); 
  //   }
    
  //   return () => clearInterval(blinkInterval);
  // }, [isSpeaking]); 
  
  // Handle image loading
  const handleImageLoad = () => {
    setLoaded(true);
    onLoad();
  };
  
  // Determine avatar source based on gender and speaking state
  let avatarSrc;
  let altText;

  if (isSpeaking) {
    avatarSrc = gender === 'male' 
      ? require('../assets/male-talking.gif') 
      : require('../assets/female-talking.gif');
    altText = `${gender} wellness rep talking`;
  } else {
    avatarSrc = gender === 'male' 
      ? require('../assets/male-therapist.png') 
      : require('../assets/female-therapist.png');
    altText = `${gender} wellness rep idle`;
  }
  
  // Map viseme to CSS class for mouth shape (for static image)
  const getMouthShapeClass = (viseme) => {
    switch(viseme) {
      case 'a-e-i': return 'mouth-a';
      case 'o-u': return 'mouth-o';
      case 'l': return 'mouth-l';
      case 'f-v': return 'mouth-f';
      case 'm-b-p': return 'mouth-m';
      case 's-z': return 'mouth-s';
      case 'th': return 'mouth-th';
      case 'r': return 'mouth-r';
      case 'w': return 'mouth-w';
      case 'closed':
      default: return 'mouth-closed';
    }
  };
  
  return (
    <div 
      className={`therapist-avatar ${gender} ${isSpeaking ? 'speaking' : ''} ${loaded ? 'loaded' : 'loading'}`}
      ref={avatarRef}
      role="img"
      aria-label={`${gender === 'male' ? 'Michael' : 'Sarah'} - ${isSpeaking ? 'Currently speaking' : 'Ready to listen'}`}
      aria-busy={!loaded}
      tabIndex={0}
    >
      <div className="avatar-container">
        <img 
          src={avatarSrc} 
          alt={altText} 
          className="avatar-image"
          onLoad={handleImageLoad}
          key={avatarSrc} // Add key to force re-render if src changes to a new GIF or back to PNG
        />
        
        {/* Status indicator for speaking state */}
        <div className="status-indicator" aria-hidden="true"></div>
        
        {/* CSS-based mouth overlay - only show if not speaking (static PNG is shown) */}
        {!isSpeaking && (
          <div className={`mouth-overlay active ${getMouthShapeClass(currentViseme)}`}>
          </div>
        )}
        
        {/* Blinking animation removed */}
        {/* {!isSpeaking && (
          <div className={`blink-overlay ${blinking ? 'blinking' : ''}`}></div>
        )} */}
      </div>
    </div>
  );
};

export default TherapistAvatar;
